import { getCurrencySetup } from '../get_currency_setup';
import { getCurrencyPattern } from '../get_currency_pattern';
import { replaceValueMarkerWithValue } from '../replace_value_marker_with_value';
import { replaceSymbolMarkerWithSymbol } from '../replace_symbol_marker_with_sumbol';
import { getFormattedNumber } from '../get_formatted_number';
import { generateSetup } from '../generate_setup';
import { flow, replace } from '../../../../lib/utilities';

export const withoutCents = (value, currencyIsoCode, noHTML, currencySetupOverrides = {}) => {
    const isNegative = value < 0;
    const setup = generateSetup(
        getCurrencySetup(currencyIsoCode),
        currencySetupOverrides,
        value
    );
    const pattern = getCurrencyPattern(noHTML, setup);
    const formattedValue = getFormattedNumber(setup, Math.abs(value));

    return flow(
        replaceSymbolMarkerWithSymbol(setup),
        replaceValueMarkerWithValue(formattedValue),
        replace.bind(this, /^/, isNegative ? '-' : ''),
    )(pattern);
};
